// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3feuR","modalFooterButton":"ModalNotes_modalFooterButton__4TWZB"};